import sharedState from '@/campaign-form-shared/store/state'

export default {
  ...sharedState,

  // Where to submit to create the petition start
  createUrl: null,

  // Where to submit to update the petition start
  updateUrl: null,

  //
  submitInProgress: false,

  // The petition start's URL once it has been created. This allows users to browse back and continue
  // with the petititon start process if they leave the page
  petitionStartUrl: null,

  // The list of all fields on the form, and which one we're currently on
  allFields: [],
  currentField: null,

  // Flag indicating if the petition start has been already created or not
  petitionStartCreated: false,

  // Petition start's token, should only have a value if it has been already created
  petitionStartToken: null,

  // When the form has been submitted, submitted values and validation errors by field
  values: {
    staffLedCampaign: null,
    partnershipId: null,
    cannotChangeAssociatedPartnership: false,
    localChapterId: null,
    title: '',
    who: '',
    what: '',
    why: '',
    locationKind: null,
    location: null,
    utmParams: {}
  },

  validationErrors: {},

  // State for the Get Help form
  requestHelpUrl: null,
  fieldToShowRequestHelpPrompt: null,
  helpRequested: false,
  userLoggedIn: false
}
